// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<customer-profile-header></customer-profile-header>
<section class="pre-terminate box">
  <sub-header header="\$ctrl.title"></sub-header>

    <missing-access-warning
      missing-access="CST_DEPOSIT_ACCOUNT_READ">
    </missing-access-warning>

    <form name="loanPreTerminate">
      <form-section>
        <loan-pre-terminate
          form-name="\$ctrl.waiveForm"
          max-values='\$ctrl.maxValues'
          priority-amortization-ids='\$ctrl.amortizationIds'
          payment-request='\$ctrl.paymentRequest'
          waive-request='\$ctrl.waiveRequest'
          loan='\$ctrl.loan'
        >
        </loan-pre-terminate>

        <form-section form-title="'Transfer account'">
          <account-select required query-field="'id'" value-field="'id'"
                          field-mapping="{accountGroup: null, accountGroupMaxLength: null, name: 'name'}"
                          options="\$ctrl.accounts" ng-model="\$ctrl.selectedAccount"></account-select>
        </form-section>

        <div class="buttons">
          <button class="btn btn-warning" ng-click="\$ctrl.redirectBack()">Cancel</button>
          <button class="btn btn-success" ng-click="\$ctrl.preTerminate()"
                  ng-disabled="!loanPreTerminate.\$valid || !\$ctrl.selectedAccount || !\$ctrl.loan">
            {{'pre-terminate' | translate:'LOAN'}}
          </button>
        </div>

        <div class="clearfix"></div>
      </form-section>
    </form>
</section>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/loans/pre-terminate/loan-pre-terminate-by-transfer.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;